// frontend/src/components/ReviewsCertifications/ReviewsCertificationsReports/ReviewsCertificationsDetail.jsx
import React, { Fragment } from "react";
import { CRUDFunction } from "../../../reduxCURD/container.js";
import { calculateCombineSets } from "../../Reports/sims/CombineMethods/CombineMethods.js";
import { DefaultChecklistReports } from "../../Reports/ReVAMP/Periodic/CheckListReports.jsx";
import { MainReservoirReport } from "../../Reports/ReVAMP/MainReservoirTest/MainReservoirTest.jsx";
import { AirBrakeReports } from "../../Reports/ReVAMP/AirBrakeReports/AirBrakeReport.jsx";
import BlueCardReportView from "../../BlueCardReport/BlueCardReportView/index.jsx";
import { getFormSummary } from "../../Reports/utils/getFormSummary.js";
import { ReportGroupingUtils } from "../../Reports/utils/reportGroupingUtils.js";
import { languageService } from "../../../Language/language.service.js";
import { arrowLeft } from "react-icons-kit/icomoon/arrowLeft.js";
import SvgIcon from "react-icons-kit";
import { printer } from "react-icons-kit/icomoon/printer";
import SpinnerLoader from "../../Common/SpinnerLoader.js";
import NonComplaintReport from "../../Reports/ReVAMP/NonComplaintMaintanence/NonComplaintMaintanence.jsx";
import { LomotiveInspection33daysReport } from "../../Reports/ReVAMP/LomotiveInspection33days/LomotiveInspection33days.jsx";
import CertifyContainer from "../../BlueCardReport/BlueCardReportView/CertifyTest/CertifyContainer.jsx";
import { themeService } from "../../../theme/service/activeTheme.service.js";
import { switchReportStyle } from "../../Reports/sims/style/index.js";
import { curdActions } from "../../../reduxCURD/actions.js";
import { Col } from "reactstrap";
import { siteReportSelctor } from "../../Reports/sims/reportFilter.jsx";
import { MyButton } from "../../Common/Forms/formsMiscItems.jsx";
import ConfirmationDialog from "../../../libraries/ConfirmationDialog/index.jsx";
import { ToastService } from "../../../utils/toastify.js";
import { ButtonStyle } from "../../../style/basic/commonControls.js";

class ReviewsCertificationsDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inspectionTests: [],
      combineSets: [],
      spinnerLoading: false,
      error: null,
      blueCardReport: null,
      selectedPerformedByUser: null,
      isBlueCardTest: false,
      confirmationDialog: null,
      blueCardYear: null,
    };
    this.handlePerformedByUserChange = this.handlePerformedByUserChange.bind(this);
  }

  componentDidMount() {
    let blueCardForms = [];
    let blueCardFrequencyLookup = {};
    this.props.applicationlookupss.forEach((lookup) => {
      if (lookup && lookup.opt1) {
        let forms = lookup.opt1.forms ? lookup.opt1.forms : [];
        blueCardForms.push(...forms);
        forms.forEach((f) => {
          blueCardFrequencyLookup[f] = lookup.opt1.frequency;
        });
      }
    });
    this.setState({
      isBlueCardTest: blueCardForms.includes(this.props.form) ? true : false,
      blueCardFrequencyLookup: blueCardFrequencyLookup,
    });

    const { getGroupReportLookup } = this.props;
    getGroupReportLookup && getGroupReportLookup("ReportGroupingLookup");
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      this.props.diagnosticsActionType === "GET_REPORT_GROUP_LOOKUP_SUCCESS" &&
      this.props.diagnosticsActionType !== prevProps.diagnosticsActionType
    ) {
      const { form, unit, reportType } = this.props;
      const testCode = form;
      const assetId = unit;

      // fetch inspection tests:
      this.props.getInspectionTests(`getInspectiontests?form=${testCode}&unit=${assetId}&type=${reportType}`);
    }
    if (this.props.actionType === "INSPECTIONTESTS_READ_REQUEST" && this.props.actionType !== prevProps.actionType) {
      this.setState({ spinnerLoading: true });
    }
    if (this.props.actionType === "INSPECTIONTESTS_READ_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      const tests = (this.props.inspectionTests && this.props.inspectionTests.inspections) || [];
      const combined = calculateCombineSets(tests, this.props.groupReportLookup);
      let blueCardYear = null;
      const isAvailableForCertification = tests.length && tests.some((t) => t.otherInfo && t.otherInfo.certifyReq);
      // if BlueCard test, fetch bluecard:
      if (tests.length && this.state.isBlueCardTest && isAvailableForCertification) {
        const { assetId, date } = tests.sort((a, b) => new Date(b.date) - new Date(a.date))[0];
        const latestTestYear = new Date(date).getFullYear();
        blueCardYear = this.props.reportType === "certified" ? latestTestYear : new Date().getFullYear();
        this.props.getBlueCards(`/getBlueCard?year=${blueCardYear}&assetId=${assetId}`);
      }

      this.setState({
        inspectionTests: tests,
        combineSets: combined.remainingTestScheds,
        spinnerLoading: false,
        isAvailableForCertification: isAvailableForCertification,
        blueCardYear: blueCardYear,
      });
    }
    if (this.props.actionType === "INSPECTIONTESTS_READ_FAILURE" && this.props.actionType !== prevProps.actionType) {
      this.setState({
        spinnerLoading: false,
        // avoid optional chaining:
        error: (this.props.errorMessage && this.props.errorMessage.toString()) || "Failed to fetch data",
      });
    }

    if (this.props.actionType === "INSPECTIONTESTS_UPDATE_SUCCESS" && this.props.actionType !== prevProps.actionType) {
      ToastService.Success("Submitted for certification successfully");
      this.props.onBack();
    }

    if (this.props.actionType === "INSPECTIONTESTS_UPDATE_FAILURE" && this.props.actionType !== prevProps.actionType) {
      ToastService.Error("Error:", "Submission Error");
      this.props.onBack();
    }

    // BlueCard lifecycle:
    if (this.props.BlueCardActionType === "BLUECARDS_READ_REQUEST" && this.props.BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: true });
    }
    if (this.props.BlueCardActionType === "BLUECARDS_READ_SUCCESS" && this.props.BlueCardActionType !== prevProps.BlueCardActionType) {
      let inspectionTests = (this.props.inspectionTests && this.props.inspectionTests.inspections) || [];
      let noOfDays = (this.props.inspectionTests && this.props.inspectionTests.noOfDays) || "";
      const enhancedData = this.prepareBlueCardCertifyData(this.props.BlueCards, inspectionTests, noOfDays);
      this.setState({
        spinnerLoading: false,
        blueCardReport: enhancedData,
      });
    }
    if (this.props.BlueCardActionType === "BLUECARDS_READ_FAILURE" && this.props.BlueCardActionType !== prevProps.BlueCardActionType) {
      this.setState({ spinnerLoading: false });
    }
  }

  handlePerformedByUserChange(e) {
    this.setState({ selectedPerformedByUser: e.target.value });
  }

  prepareBlueCardCertifyData(blueCardData, inspectionTests, noOfDays) {
    if (this.props.reportType === "certified") return blueCardData;
    const enhanced = JSON.parse(JSON.stringify(blueCardData));
    if (!enhanced.summary) enhanced.summary = {};
    let certifyUserList = [];
    let certifyTestSchedules = [];
    inspectionTests.forEach((test, index) => {
      const testCode = test.testCode;
      if (!testCode) return;
      let isLastTest = index === inspectionTests.length - 1;
      const formDataObj = getFormSummary({ form: test.formData });
      const numPeriods = this.getNoOfPeriods(testCode);
      const userName = (test.user && test.user.name) || "";
      if (!certifyUserList.some((u) => u.id === (test.user && test.user.id))) {
        certifyUserList.push(test.user);
      }
      certifyTestSchedules.push(test._id.toString());
      const periodData = {
        Date: new Date(),
        Place: formDataObj.locationName || "",
        Name: userName,
        noOfDays: noOfDays,
        Id: test._id.toString(),
        FormData: { ...formDataObj },
        Cert: test.otherInfo && test.otherInfo.certifiedBy,
        blueCardCertify: { certify: true },
        ...(isLastTest ? { blueCardCertify: { certify: true, userList: certifyUserList, testSchedulesList: certifyTestSchedules } } : {}),
      };

      let updatedSummaryData = this.injectPeriod(enhanced.summary[testCode], numPeriods, periodData);
      enhanced.summary[testCode] = {
        ...updatedSummaryData,
      };
    });

    return enhanced;
  }

  getNoOfPeriods(key) {
    let noOfPeriods = null;
    noOfPeriods = this.state.blueCardFrequencyLookup[key];
    return noOfPeriods;
  }

  injectPeriod(data, limit, newPeriod) {
    const originalData = data && typeof data === "object" ? data : {};
    const periods = [];
    for (let i = 1; originalData[`period${i}Id`] !== undefined; i++) {
      periods.push({
        Date: originalData[`period${i}Date`],
        Name: originalData[`period${i}Name`],
        Cert: originalData[`period${i}Cert`] || "",
        Place: originalData[`period${i}Place`],
        Id: originalData[`period${i}Id`],
        FormData: originalData[`period${i}FormData`],
        blueCardCertify: originalData[`period${i}blueCardCertify`],
      });
    }
    if (limit !== null && periods.length >= limit) {
      periods.shift();
    }
    periods.push(newPeriod);
    const newData = { ...originalData };
    newData[`noOfDays`] = newPeriod.noOfDays;
    newData[`testConfigured`] = true;
    periods.forEach((period, index) => {
      const idx = index + 1;
      period.Date && (newData[`period${idx}Date`] = period.Date);
      newData[`period${idx}Name`] = period.Name;
      newData[`period${idx}Cert`] = period.Cert;
      newData[`period${idx}Place`] = period.Place;
      newData[`period${idx}Id`] = period.Id;
      newData[`period${idx}FormData`] = period.FormData;
      period.blueCardCertify && (newData[`period${idx}blueCardCertify`] = period.blueCardCertify);
    });
    return newData;
  }

  renderReportForTestSchedule(reportSet) {
    const testCodes = Array.isArray(reportSet.testCodes) ? reportSet.testCodes : [reportSet.testCode];

    const data =
      (this.props.inspectionTests && this.props.inspectionTests.inspections.filter((ts) => testCodes.includes(ts.testCode))) || [];
    let dataWithItemsTableField = ReportGroupingUtils.convertToTableField(
      data,
      ["item1", "item2", "item3", "item4", "item5", "item6", "item7"],
      "inspector_items",
    );
    // PATH tests to skip injecting user fields as the reports already do it, can get these from configs in the future
    const testsToSkipInjectorFields = ["path_92DaysForm"];
    let dataForCertification = ReportGroupingUtils.combineMultipleUserReportDataByDate(
      dataWithItemsTableField,
      this.props.reportType === "certified",
      testsToSkipInjectorFields.includes(reportSet.testCode),
    );
    let lampReport = siteReportSelctor(
      reportSet.testCode,
      dataForCertification,
      reportSet.assetName,
      reportSet.assetId,
      null,
      this.props.allUsers,
    );
    return (
      <React.Fragment>
        {lampReport}
        {!this.state.isBlueCardTest && this.props.reportType === "pending" && (
          <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
            <div style={{ display: "flex", alignItems: "center" }}>
              <div style={{ flex: "0 0 auto", marginRight: "16px", fontWeight: "bold", fontSize: "18px" }}>Certified By:</div>
              <div style={{ flex: "1" }}>
                <CertifyContainer
                  certifiedBy={dataForCertification[0].otherInfo && dataForCertification[0].otherInfo.certifiedBy}
                  testIds={dataForCertification[0].testSchedulesList}
                  userList={dataForCertification[0].filledByUserList}
                  handleCertifyClick={this.props.onBack}
                  type="test"
                />
              </div>
            </div>
          </div>
        )}
      </React.Fragment>
    );
  }
  closeConfirmationDialog = () => {
    this.setState({ confirmationDialog: null });
  };

  markTestComplete = () => {
    const dataToSend = { testCode: this.props.form, assetId: this.props.unit };

    this.props.updateInspectionTests(dataToSend, "submitForCertification");
    this.closeConfirmationDialog();
  };

  openConfirmationDialog = () => {
    this.setState({
      confirmationDialog: (
        <ConfirmationDialog
          title="Confirm"
          body={<Fragment>Are you sure you want to submit this test for certification?</Fragment>}
          action="certify"
          cancelCallback={this.closeConfirmationDialog}
          confirmationCallback={this.markTestComplete}
        />
      ),
    });
  };

  render() {
    const { spinnerLoading, error, combineSets, inspectionTests, blueCardReport, isAvailableForCertification, blueCardYear } = this.state;

    return (
      <div>
        <SpinnerLoader spinnerLoading={spinnerLoading} />
        {this.state.confirmationDialog}
        {/* Back & Print controls */}
        <div className="report-controls" style={{ width: "100%", marginBottom: "60px", padding: "15px" }}>
          <div
            className="report-arrow"
            style={{ margin: "15px 15px 10px 0", cursor: "pointer", float: "left", textAlign: "center" }}
            onClick={(e) => {
              // call onBack prop
              if (this.props.onBack) {
                this.props.onBack();
              }
            }}
          >
            <span style={{ verticalAlign: "super", marginLeft: "5px", fontSize: "12px", display: "block" }}>
              {languageService("Reports Menu")}
            </span>
            <SvgIcon icon={arrowLeft} size={24} />
          </div>

          <div
            className="report-print"
            style={{ margin: "15px 0 0 15px", cursor: "pointer", float: "right", textAlign: "center" }}
            onClick={(e) => window.print()}
          >
            <span style={{ verticalAlign: "super", marginRight: "5px", fontSize: "12px", display: "block" }}>
              {languageService("Print Report")}
            </span>
            <SvgIcon icon={printer} size={24} />
          </div>
        </div>

        {combineSets && combineSets[0] && this.renderReportForTestSchedule(combineSets[0])}

        {blueCardReport && (
          <div style={{ marginTop: "2rem" }}>
            <BlueCardReportView
              reportData={blueCardReport}
              year={blueCardYear}
              selectedPerformedByUser={this.state.selectedPerformedByUser}
              handlePerformedByUserChange={this.handlePerformedByUserChange}
              handleCertifyClick={this.props.onBack}
              blueCardSectionsLookups={this.props.applicationlookupss}
            />
          </div>
        )}
        {inspectionTests && inspectionTests.length > 0 && !isAvailableForCertification && this.props.reportType === "inProgress" && (
          <MyButton
            className="no-print"
            style={{ ...themeService(ButtonStyle.commonButton), fontSize: "18px", fontWeight: "100" }}
            onClick={this.openConfirmationDialog}
          >
            Submit for Certification
          </MyButton>
        )}
      </div>
    );
  }
}

// CRUDFunction injection:

let actionOptions = {
  create: false,
  update: true,
  read: true,
  delete: false,
};

const ReviewsCertificationsDetailContainer = CRUDFunction(
  ReviewsCertificationsDetail,
  "inspectionTests",
  actionOptions,
  null,
  [],
  "testSchedule",
);

export default ReviewsCertificationsDetailContainer;



// WEBPACK FOOTER //
// ./src/components/ReviewsCertifications/TestsReviewCertification/TestsReviewCertificationDetail.jsx